export default "__VITE_ASSET__BMPfF3Oy__"